import DashboardComponent from './Dashboard/index';

export default function Dashboard() {
  return <DashboardComponent />;
}